import React from "react";
import {Button, Form, Input, message, Modal} from "antd";
import ManagerRepo from '../../repository/manager';

class NewManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
    }
  }

  save = () => {
    const form = this.props.form;

    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      this.setState({
        loading: true,
      });

      ManagerRepo.create(this.props.business.id, values).then(
        result => {
          this.setState({loading: false});
          this.close();
          message.success('Manager was created');
        },
        error => {
          this.setState({loading: false});
          message.error('Error creating manager:' + error.response.data.message);
          console.log(error.response);
        },
      )
    });
  }

  close = () => {
    this.props.setVisible(false)
  }

  render() {
    const {getFieldDecorator} = this.props.form;

    return (
      <Modal
        visible={this.props.visible || false}
        title="Add a new manager"
        onOk={this.save}
        onCancel={this.close}
        footer={[
          <Button key="back" onClick={this.close}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" loading={this.state.loading} onClick={this.save}>
            Invite
          </Button>,
        ]}
      >
        <Form layout="vertical">
          <Form.Item label="E-mail">
            {getFieldDecorator('email', {
              rules: [
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!',
                },
                {
                  required: true,
                  message: 'Please input your E-mail!',
                },
              ],
            })(<Input />)}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({name: 'add_manager'})(NewManager);